<template>
  <div class="printSmallPayFee-container">
    <!-- 多收据显示 - 只显示一次表头 -->
    <div class="print_container" v-if="printSmallPayFeeInfo.receipts && printSmallPayFeeInfo.receipts.length > 0">
      <div style="color:#000;font-size:32px" class="text-center">
        <span>{{ $t('printSmallPayFee.receipt') }}</span>
      </div>
      <span>**************************</span>
      <div class="section2" style="font-size: 12px; margin-left: 5px;">
        <!-- 显示第一张收据的信息作为主表头 -->
        <div v-if="printSmallPayFeeInfo.receipts.length > 0">
          <div>
            <span>{{ $t('printSmallPayFee.receiptNum') }}: </span>{{ printSmallPayFeeInfo.receipts[0].receiptNum }}
          </div>
          <div>
            <span>{{ $t('printSmallPayFee.orderNum') }}: </span>{{ printSmallPayFeeInfo.receipts[0].payOrderId }}
          </div>
          <div>
            <span>{{ $t('printSmallPayFee.roomNum') }}: </span>{{ printSmallPayFeeInfo.receipts[0].roomName }}
          </div>
          <div>
            <span>{{ $t('printSmallPayFee.owner') }}: </span>{{ printSmallPayFeeInfo.receipts[0].payObjName }}
          </div>
          <div>
            <span>{{ $t('printSmallPayFee.time') }}: </span>{{ printSmallPayFeeInfo.receipts[0].feeTime }}
          </div>
        </div>
      </div>
      <span>**************************</span>

      <!-- 逐张收据显示：该张收据的费用项 + 电费/服务费合计 + 该张收据的打印规格 -->
      <div v-for="(receipt, rIndex) in printSmallPayFeeInfo.receipts" :key="rIndex">
        <!-- 如果有多张收据，显示收据编号标识 -->
        <!-- <div v-if="printSmallPayFeeInfo.receipts.length > 1"
          style="font-size: 12px; margin-left: 5px; margin-top: 10px;">
          <strong>{{ $t('printSmallPayFee.receiptNum') }}: {{ receipt.receiptNum }}</strong>
        </div> -->

        <div class="section2" style="font-size: 12px; margin-left: 5px;" v-for="(item, index) in receipt.fees"
          :key="index">
          <div>
            <span>{{ $t('printSmallPayFee.feeItem') }}: </span>{{ item.feeName }}
          </div>
          <div>
            <span>{{ $t('printSmallPayFee.feeRange') }}: </span>{{ formatDate(item.startTime) }}
            <span>{{ $t('printSmallPayFee.to') }}</span>{{ formatDate(item.endTime) }}
          </div>
          <div>
            <span>{{ $t('printSmallPayFee.unitPrice') }}</span>{{ item.squarePrice }}
          </div>
          <div>
            <span>{{ $t('printSmallPayFee.areaUsage') }}</span>{{ item.area }}
          </div>
          <div>
            <span>{{ $t('printSmallPayFee.paymentMethod') }}</span>{{ item.primeRate }}
          </div>
          <div v-if="item.preDegrees">
            <span>{{ $t('printSmallPayFee.meterReading') }}</span>{{ item.preDegrees }} {{ $t('printSmallPayFee.to') }}
            {{ item.curDegrees }}
          </div>
          <div>
            <span>{{ $t('printSmallPayFee.amount') }}</span>
            <span>{{ formatAmount(item.amount) }}</span>
          </div>
          <div v-if="hasSplit(item)">
            <span>{{ $t('printSmallPayFee.' + getItemAmountLabelKey(item)) }}</span>
            <span>{{ formatElectricAmount(item.electricAmount) }}</span>
          </div>
          <div v-if="hasSplit(item)">
            <span>{{ $t('printSmallPayFee.serviceAmount') }}</span>
            <span>{{ formatServiceAmount(item.serviceAmount) }}</span>
          </div>
          <div>
            <span>{{ $t('printSmallPayFee.discount') }}</span> {{ item.discountPrice || 0 }}
          </div>
          <div>
            <span>{{ $t('printSmallPayFee.remark') }}: </span>{{ item.remark }}
          </div>
          <span>**************************</span>
        </div>

      </div>

      <!-- 合计：永远显示一行。
           多个收费项目 → 「全部收据合计」；只有 1 个收费项目 → 「合计」；
           有服务费时再附带电费/服务费合计 -->
      <div class="section5" style="font-size: 12px; margin-left: 5px;">
        <div>
          <span>{{ totalFeeItemCount > 1 ? $t('printSmallPayFee.allReceiptsTotal') : $t('printSmallPayFee.total') }}:
          </span>{{ getTotalAmount() }}
        </div>
        <div v-if="hasServiceFeeAny()">
          <span>{{ $t('printSmallPayFee.' + getTotalAmountLabelKey()) }}:
          </span>{{ printSmallPayFeeInfo.electricTotal }}
        </div>
        <div v-if="hasServiceFeeAny()">
          <span>{{ totalFeeItemCount > 1 ? $t('printSmallPayFee.allServiceTotal') : $t('printSmallPayFee.serviceTotal') }}:
          </span>{{ printSmallPayFeeInfo.serviceTotal }}
        </div>
      </div>
      <span>**************************</span>

      <!-- 经办人 + 打印规格 + 二维码：整单只打印一次，避免多张收据时重复出现二维码 -->
      <div class="section5" style="font-size: 12px; margin-left: 5px;">
        <div>
          <span>{{ $t('printSmallPayFee.issuer') }}: </span>{{ userInfo.name }}
        </div>
        <div v-if="printSmallPayFeeInfo.receipts[0].content" v-html="printSmallPayFeeInfo.receipts[0].content"></div>
        <div v-if="printSmallPayFeeInfo.receipts[0].qrImg"><img :src="printSmallPayFeeInfo.receipts[0].qrImg"
            width="100px" height="100px"></div>
      </div>
      <span>**************************</span>
    </div>

    <!-- 原有单据显示方式，用于兼容只有一张收据的情况 -->
    <div class="print_container" v-if="!printSmallPayFeeInfo.receipts || printSmallPayFeeInfo.receipts.length === 0">
      <div style="color:#000;font-size:32px" class="text-center">
        <span>{{ $t('printSmallPayFee.receipt') }}</span>
      </div>
      <span>**************************</span>
      <div class="section2" style="font-size: 12px; margin-left: 5px;">
        <div>
          <span>{{ $t('printSmallPayFee.receiptNum') }}</span>{{ printSmallPayFeeInfo.receiptNum }}
        </div>
        <div>
          <span>{{ $t('printSmallPayFee.orderNum') }}</span>{{ printSmallPayFeeInfo.payOrderId }}
        </div>
        <div>
          <span>{{ $t('printSmallPayFee.roomNum') }}</span>: {{ printSmallPayFeeInfo.roomName }}
        </div>
        <div>
          <span>{{ $t('printSmallPayFee.owner') }}</span>: {{ printSmallPayFeeInfo.payObjName }}
        </div>
        <div>
          <span>{{ $t('printSmallPayFee.time') }}</span>: {{ printSmallPayFeeInfo.feeTime }}
        </div>
      </div>
      <span>**************************</span>
      <div class="section2" style="font-size: 12px; margin-left: 5px;"
        v-for="(item, index) in printSmallPayFeeInfo.fees" :key="index">
        <div>
          <span>{{ $t('printSmallPayFee.feeItem') }}</span>: {{ item.feeName }}
        </div>
        <div>
          <span>{{ $t('printSmallPayFee.feeRange') }}</span>: {{ formatDate(item.startTime) }}
          <span>{{ $t('printSmallPayFee.to') }}</span>{{ formatDate(item.endTime) }}
        </div>
        <div>
          <span>{{ $t('printSmallPayFee.unitPrice') }}</span>{{ item.squarePrice }}
        </div>
        <div>
          <span>{{ $t('printSmallPayFee.areaUsage') }}</span>{{ item.area }}
        </div>
        <div>
          <span>{{ $t('printSmallPayFee.paymentMethod') }}</span>{{ item.primeRate }}
        </div>
        <div v-if="item.preDegrees">
          <span>{{ $t('printSmallPayFee.meterReading') }}</span>{{ item.preDegrees }} {{ $t('printSmallPayFee.to') }}
          {{ item.curDegrees }}
        </div>
        <div>
          <span>{{ $t('printSmallPayFee.amount') }}</span>
          <span>{{ formatAmount(item.amount) }}</span>
        </div>
        <div v-if="hasSplit(item)">
          <span>{{ $t('printSmallPayFee.' + getItemAmountLabelKey(item)) }}</span>
          <span>{{ formatElectricAmount(item.electricAmount) }}</span>
        </div>
        <div v-if="hasSplit(item)">
          <span>{{ $t('printSmallPayFee.serviceAmount') }}</span>
          <span>{{ formatServiceAmount(item.serviceAmount) }}</span>
        </div>
        <div>
          <span>{{ $t('printSmallPayFee.discount') }}</span> {{ item.discountPrice || 0 }}
        </div>
        <div>
          <span>{{ $t('printSmallPayFee.remark') }}</span>: {{ item.remark }}
        </div>
        <span>**************************</span>
      </div>
      <div class="section5" style="font-size: 12px; margin-left: 5px;">
        <div>
          <span>{{ totalFeeItemCount > 1 ? $t('printSmallPayFee.allReceiptsTotal') : $t('printSmallPayFee.total') }}</span>: {{ printSmallPayFeeInfo.amount }}
        </div>
        <div v-if="hasServiceFeeAny()">
          <span>{{ $t('printSmallPayFee.' + getTotalAmountLabelKey()) }}</span>: {{ printSmallPayFeeInfo.electricTotal }}
        </div>
        <div v-if="hasServiceFeeAny()">
          <span>{{ $t('printSmallPayFee.serviceTotal') }}</span>: {{ printSmallPayFeeInfo.serviceTotal }}
        </div>
        <div>
          <span>{{ $t('printSmallPayFee.issuer') }}</span>: {{ userInfo.name }}
        </div>
        <div v-html="printSmallPayFeeInfo.content"></div>
        <div><img :src="printSmallPayFeeInfo.qrImg" width="100px" height="100px"></div>
      </div>
      <span>**************************</span>
    </div>

    <div id="print-btn" class="action-buttons">
      <el-button type="primary" class="float-right" @click="handlePrint">
        <i class="el-icon-printer"></i>&nbsp;{{ $t('printSmallPayFee.print') }}
      </el-button>
      <el-button class="float-right margin-right" @click="handleCloudPrint">
        <i class="el-icon-cloudy"></i>&nbsp;{{ $t('printSmallPayFee.cloudPrint') }}
      </el-button>
      <el-button class="float-right margin-right" @click="handleClose">
        <span>{{ $t('printSmallPayFee.cancel') }}</span>
      </el-button>
    </div>


    <el-dialog :title="$t('printSmallPayFee.cloudPrint')" :visible.sync="cloudPrintVisible" width="50%">
      <div class="cloud-print-content">
        <el-form label-width="120px">
          <el-form-item :label="$t('printSmallPayFee.printer')">
            <el-select v-model="printSmallPayFeeInfo.machineId" style="width:100%"
              :placeholder="$t('printSmallPayFee.printerRequired')">
              <el-option v-for="(item, index) in printSmallPayFeeInfo.machines" :key="index"
                :label="`${item.machineName}(${item.machineCode})`" :value="item.machineId" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('printSmallPayFee.quantity')">
            <el-input v-model="printSmallPayFeeInfo.quantity" type="number"
              :placeholder="$t('printSmallPayFee.quantityRequired')" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('printSmallPayFee.cancel') }}</el-button>
        <el-button type="primary" @click="handleSubmitCloudPrint">{{ $t('printSmallPayFee.submit') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryFeeReceipt,
  queryFeeReceiptDetail,
  queryFeePrintSpec,
  listMachinePrinter,
  printPayFeeDetail
} from '@/api/fee/printSmallPayFeeApi'
import { getCommunityId } from '@/api/community/communityApi'
import { getUserId, getUserName } from '@/api/user/userApi'
import { getMeterFeeLabelKey } from '@/utils/feeSplitUtil'

export default {
  name: 'PrintSmallPayFeeList',
  data() {
    return {
      printSmallPayFeeInfo: {
        communityName: '',
        receiptId: '',
        receiptIds: '',
        receiptNum: '',
        payOrderId: '',
        roomName: '',
        amount: 0.00,
        electricTotal: '0.00',
        serviceTotal: '0.00',
        fees: [],
        feeTime: '',
        wechatName: '',
        content: '',
        qrImg: '',
        payObjName: '',
        machineId: '',
        quantity: '1',
        machines: [],
        receipts: [] // 添加用于存储多个收据的数组
      },
      cloudPrintVisible: false,
      userInfo: {}
    }
  },
  created() {
    // 处理receiptId参数
    this.printSmallPayFeeInfo.receiptId = this.$route.query.receiptId || ''

    // 处理receiptIds参数，确保是字符串并去除首尾空格
    const receiptIds = this.$route.query.receiptIds
    this.printSmallPayFeeInfo.receiptIds = receiptIds ? String(receiptIds).trim() : ''

    // 设置社区名称
    this.printSmallPayFeeInfo.communityName = getCommunityId().name

    // 加载数据
    this.loadData()

    // 设置用户信息
    this.userInfo = {
      userId: getUserId(),
      name: getUserName()
    }
  },
  computed: {
    // 整单（本次打印的所有收据加起来）的收费项目总数：
    //   1 个 → 显示「合计」；多个 → 不显示各自合计，只显示「全部收据合计」
    totalFeeItemCount() {
      const receipts = this.printSmallPayFeeInfo.receipts || []
      if (receipts.length > 0) {
        return receipts.reduce((n, r) => n + ((r.fees || []).length), 0)
      }
      return (this.printSmallPayFeeInfo.fees || []).length
    }
  },
  methods: {
    async loadData() {
      await this.loadReceipt()
      // 如果有多个收据，则为每个收据加载详细信息
      if (this.printSmallPayFeeInfo.receipts && this.printSmallPayFeeInfo.receipts.length > 0) {
        await this.loadMultipleReceiptDetails()
      } else {
        await this.loadReceiptDetail()
      }
      await this.loadPrintSpec()
    },

    // 计算多个收据的总金额
    getTotalAmount() {
      if (this.printSmallPayFeeInfo.receipts && this.printSmallPayFeeInfo.receipts.length > 0) {
        let total = 0
        this.printSmallPayFeeInfo.receipts.forEach(receipt => {
          total += parseFloat(receipt.amount) || 0
        })
        return total.toFixed(2)
      }
      return this.printSmallPayFeeInfo.amount || '0.00'
    },

    async loadMultipleReceiptDetails() {
      try {
        // 先用通用方法加载所有详细信息
        await this.loadReceiptDetail()
      } catch (error) {
        console.error('Failed to load multiple receipt details:', error)
      }
    },
    async loadReceipt() {
      try {
        const params = {
          page: 1,
          row: 100, // 增加row数量以获取所有收据
          receiptId: this.printSmallPayFeeInfo.receiptId,
          receiptIds: this.printSmallPayFeeInfo.receiptIds,
          communityId: getCommunityId()
        }
        const { data } = await queryFeeReceipt(params)
        const _feeReceipt = data

        // 如果有多个收据ID，需要分别处理
        if (this.printSmallPayFeeInfo.receiptIds && _feeReceipt.length > 0) {
          // 多个收据的情况
          this.printSmallPayFeeInfo.receipts = _feeReceipt.map(receipt => {
            let _amount = 0
            _amount = parseFloat(receipt.amount)

            return {
              receiptNum: receipt.receiptCode,
              payOrderId: receipt.payOrderId,
              roomName: receipt.objName,
              payObjName: receipt.payObjName,
              feeTime: receipt.createTime,
              amount: _amount.toFixed(2),
              electricTotal: '0.00',
              serviceTotal: '0.00',
              content: '',
              qrImg: '',
              receiptId: receipt.receiptId
            }
          })
        } else if (_feeReceipt.length > 0) {
          // 单个收据的情况
          let _amount = 0
          _feeReceipt.forEach(item => {
            _amount += parseFloat(item.amount)
          })
          this.printSmallPayFeeInfo.amount = _amount.toFixed(2)
          this.printSmallPayFeeInfo.roomName = _feeReceipt[0].objName
          this.printSmallPayFeeInfo.feeTime = _feeReceipt[0].createTime
          this.printSmallPayFeeInfo.payObjName = _feeReceipt[0].payObjName
          this.printSmallPayFeeInfo.receiptNum = _feeReceipt[0].receiptCode
          this.printSmallPayFeeInfo.payOrderId = _feeReceipt[0].payOrderId
        }
      } catch (error) {
        console.error('Failed to load receipt:', error)
      }
    },
    async loadReceiptDetail() {
      try {
        const params = {
          page: 1,
          row: 300, // 增加row数量以获取所有详细信息
          receiptId: this.printSmallPayFeeInfo.receiptId,
          receiptIds: this.printSmallPayFeeInfo.receiptIds,
          communityId: getCommunityId(),
          orderBy: 'start_time'
        }
        const { data } = await queryFeeReceiptDetail(params)

        if (data && data.length > 0) {
          // 按receiptId分组费用项
          if (this.printSmallPayFeeInfo.receipts && this.printSmallPayFeeInfo.receipts.length > 0) {
            // 多个收据的情况
            const groupedFees = {}
            data.forEach(fee => {
              if (!groupedFees[fee.receiptId]) {
                groupedFees[fee.receiptId] = []
              }
              groupedFees[fee.receiptId].push(fee)
            })

            // 将费用项分配给对应的收据，并逐张累计电费/服务费合计
            let electricAll = 0
            let serviceAll = 0
            this.printSmallPayFeeInfo.receipts.forEach(receipt => {
              receipt.fees = groupedFees[receipt.receiptId] || []
              // 如果该收据还没有payOrderId，则从费用项中获取
              if (!receipt.payOrderId && receipt.fees.length > 0) {
                receipt.payOrderId = receipt.fees[0].payOrderId
              }
              // 计算该收据的总金额、电费合计、服务费合计
              let receiptAmount = 0
              let electricTotal = 0
              let serviceTotal = 0
              receipt.fees.forEach(fee => {
                receiptAmount += parseFloat(fee.amount || 0)
                electricTotal += parseFloat(fee.electricAmount || 0)
                serviceTotal += parseFloat(fee.serviceAmount || 0)
              })
              receipt.amount = receiptAmount.toFixed(2)
              receipt.electricTotal = electricTotal.toFixed(2)
              receipt.serviceTotal = serviceTotal.toFixed(2)
              electricAll += electricTotal
              serviceAll += serviceTotal
            })

            // 全部收据的电费/服务费合计
            this.printSmallPayFeeInfo.electricTotal = electricAll.toFixed(2)
            this.printSmallPayFeeInfo.serviceTotal = serviceAll.toFixed(2)
          } else {
            // 单个收据的情况
            this.printSmallPayFeeInfo.payOrderId = data[0].payOrderId
            let electricTotal = 0.0
            let serviceTotal = 0.0
            data.forEach(item => {
              electricTotal += parseFloat(item.electricAmount || 0)
              serviceTotal += parseFloat(item.serviceAmount || 0)
            })
            this.printSmallPayFeeInfo.fees = data
            this.printSmallPayFeeInfo.electricTotal = electricTotal.toFixed(2)
            this.printSmallPayFeeInfo.serviceTotal = serviceTotal.toFixed(2)
          }
        }
      } catch (error) {
        console.error('Failed to load receipt detail:', error)
      }
    },
    async loadPrintSpec() {
      try {
        const params = {
          page: 1,
          row: 1,
          specCd: 2020,
          communityId: getCommunityId()
        }
        const { data } = await queryFeePrintSpec(params)
        if (data.length > 0) {
          // 如果有多个收据，为每个收据设置打印规格
          if (this.printSmallPayFeeInfo.receipts && this.printSmallPayFeeInfo.receipts.length > 0) {
            this.printSmallPayFeeInfo.receipts.forEach(receipt => {
              receipt.content = data[0].content
              receipt.qrImg = data[0].qrImg
            })
          } else {
            // 单个收据的情况
            this.printSmallPayFeeInfo.content = data[0].content
            this.printSmallPayFeeInfo.qrImg = data[0].qrImg
          }
        }
      } catch (error) {
        console.error('Failed to load print spec:', error)
      }
    },
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleDateString()
    },
    formatAmount(amount) {
      if (amount < 0) {
        return amount + this.$t('printSmallPayFee.refund')
      }
      return amount
    },
    // 明细行金额标题：水费金额 / 电费金额 / 水、电费金额
    getItemAmountLabelKey(item) {
      const key = getMeterFeeLabelKey(item)
      if (key === 'waterFee') return 'waterAmount'
      if (key === 'meterFee') return 'meterAmount'
      return 'electricAmount'
    },
    // 所有发生拆分的费用项（多收据时从每张收据里汇总）
    splitFees() {
      const list = []
      const receipts = this.printSmallPayFeeInfo.receipts || []
      receipts.forEach(receipt => {
        const fees = receipt.fees || []
        fees.forEach(fee => list.push(fee))
      })
      if (list.length === 0) {
        const fees = this.printSmallPayFeeInfo.fees || []
        fees.forEach(fee => list.push(fee))
      }
      return list.filter(fee => fee && fee.electricAmount !== null && fee.electricAmount !== undefined && fee.electricAmount !== '')
    },
    // 合计区金额标题：全水费→水费金额合计；全电费→电费金额合计；混排/识别不出→水、电费金额合计
    getTotalAmountLabelKey() {
      const splitFees = this.splitFees()
      let type = 'electric'
      if (splitFees.length > 0) {
        const keys = splitFees.map(fee => getMeterFeeLabelKey(fee))
        if (keys.every(key => key === 'waterFee')) {
          type = 'water'
        } else if (!keys.every(key => key === 'electricFee')) {
          type = 'meter'
        }
      }
      const multi = this.totalFeeItemCount > 1
      if (type === 'water') return multi ? 'allWaterTotal' : 'waterTotal'
      if (type === 'meter') return multi ? 'allMeterTotal' : 'meterTotal'
      return multi ? 'allElectricTotal' : 'electricTotal'
    },
    // 该费用项是否有「电费/服务费」拆分数据：
    // 只有 5006/9010（含服务费）且服务费单价 > 0 才会拆分；
    // 非水电费项目（物业费、租金等）没有拆分 -> 明细里不显示「电费金额/服务费金额」两行
    hasSplit(item) {
      const e = item && item.electricAmount
      return e !== null && e !== undefined && e !== ''
    },
    // 整单是否有服务费（单收据 / 多收据 / 明细任一有）
    hasServiceFeeAny() {
      if (parseFloat(this.printSmallPayFeeInfo.serviceTotal || 0) > 0) return true
      const fees = this.printSmallPayFeeInfo.fees || []
      if (fees.some(f => parseFloat(f.serviceAmount || 0) > 0)) return true
      const receipts = this.printSmallPayFeeInfo.receipts || []
      return receipts.some(r => parseFloat(r.serviceTotal || 0) > 0)
    },
    formatElectricAmount(electricAmount) {
      if (electricAmount === null || electricAmount === undefined || electricAmount === '') {
        return '—'
      }
      return parseFloat(electricAmount).toFixed(2)
    },
    formatServiceAmount(serviceAmount) {
      if (serviceAmount === null || serviceAmount === undefined || serviceAmount === '') {
        return '—'
      }
      const amount = parseFloat(serviceAmount)
      return amount === 0 ? '—' : amount.toFixed(2)
    },
    handlePrint() {
      window.print()
    },
    handleCloudPrint() {
      this.listMachinePrinter()
      this.cloudPrintVisible = true
    },
    async listMachinePrinter() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: getCommunityId()
        }
        const { data } = await listMachinePrinter(params)
        this.printSmallPayFeeInfo.machines = data
        if (this.printSmallPayFeeInfo.machines && this.printSmallPayFeeInfo.machines.length > 0) {
          this.printSmallPayFeeInfo.machineId = this.printSmallPayFeeInfo.machines[0].machineId
        }
      } catch (error) {
        console.error('Failed to list machine printer:', error)
      }
    },
    async handleSubmitCloudPrint() {
      try {
        let detailIds = [];
        // 检查是否有多收据情况
        if (this.printSmallPayFeeInfo.receipts && this.printSmallPayFeeInfo.receipts.length > 0) {
          // 从所有收据中收集detailIds
          this.printSmallPayFeeInfo.receipts.forEach(receipt => {
            if (receipt.fees && receipt.fees.length > 0) {
              receipt.fees.forEach(fee => {
                if (fee.detailId) {
                  detailIds.push(fee.detailId);
                }
              });
            }
          });
        } else {
          // 单收据情况
          detailIds = this.printSmallPayFeeInfo.fees.map(item => item.detailId);
        }

        if (detailIds.length < 1) {
          this.$message.error(this.$t('printSmallPayFee.noFee'));
          return;
        }

        const data = {
          communityId: getCommunityId(),
          machineId: this.printSmallPayFeeInfo.machineId,
          quantity: this.printSmallPayFeeInfo.quantity,
          detailId: detailIds.join(',')
        };

        const { code, msg } = await printPayFeeDetail(data);
        if (code != 0) {
          this.$message.error(msg);
          return;
        }

        this.cloudPrintVisible = false;
        this.$message.success(this.$t('common.operationSuccess'));
      } catch (error) {
        console.error('Failed to submit cloud print:', error);
        this.$message.error(error.message || this.$t('printSmallPayFee.submitFailed'));
      }
    },
    handleClose() {
      window.close()
    }
  }
}
</script>

<style scoped>
.printSmallPayFee-container {
  padding: 20px;
}

.print_container {
  padding: 20px;
  background: #fff;
}

.text-center {
  text-align: center;
}

.section2,
.section5 {
  margin-bottom: 15px;
}

.action-buttons {
  margin-top: 20px;
  text-align: right;
}

.float-right {
  float: right;
}

.margin-right {
  margin-right: 10px;
}

.cloud-print-content {
  padding: 20px;
}
</style>
